module.exports = __webpack_public_path__ + "img/machine-volante.0d8a7cca.jpg";